"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translatePayment = exports.translateMethod = exports.i18nMethodByLang = void 0;
const lodash_1 = require("lodash");
const sumPaymentReceipts_1 = require("./sumPaymentReceipts");
exports.i18nMethodByLang = {
    en: {
        cash: 'Cash',
        check: 'Bank Check',
        card: 'Bank Card',
        transfer: 'Transfer',
        ancv: 'ANCV',
        paypal: 'PayPal',
        systempay: 'Systempay',
        other: 'Other',
    },
    fr: {
        cash: 'Espèce',
        check: 'Chèque Bancaire',
        card: 'Carte Bancaire',
        transfer: 'Virement Bancaire',
        ancv: 'ANCV',
        paypal: 'PayPal',
        systempay: 'Systempay',
        other: 'Autre',
    },
};
function translateMethod(method, lang) {
    return exports.i18nMethodByLang[lang][method];
}
exports.translateMethod = translateMethod;
const translatePayment = (payment, lang) => {
    const byMethodReceipts = lodash_1.groupBy(payment.receipts, (receipt) => receipt.method);
    const receipts = lodash_1.mapValues(byMethodReceipts, (receipts, method) => ({
        amountInEuro: sumPaymentReceipts_1.sumReceipts(receipts),
        method: translateMethod(method, lang),
    }));
    return Object.assign(Object.assign({}, payment), { receipts: lodash_1.values(receipts) });
};
exports.translatePayment = translatePayment;
//# sourceMappingURL=translatePayment.js.map